var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7945_6867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.98554 10.7965L4.96875 14.8617L9.03494 13.8459L15.1337 7.74709L12.0843 4.69769L5.98554 10.7965Z",
    stroke: "#6921C4",
    strokeWidth: 1.43749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6875 4.18884L19.7043 5.20563C19.9738 5.4752 20.1252 5.84076 20.1252 6.22194C20.1252 6.60311 19.9738 6.96867 19.7043 7.23824L16.5312 10.4113",
    stroke: "#FF6019",
    strokeWidth: 1.43749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1275 7.74712L18.6848 4.18885C18.9543 3.91928 19.1057 3.55371 19.1057 3.17254C19.1057 2.79137 18.9543 2.4258 18.6848 2.15623L17.6681 1.13945C17.3985 0.869957 17.0329 0.718567 16.6517 0.718567C16.2706 0.718567 15.905 0.869957 15.6354 1.13945L12.0781 4.6958",
    stroke: "#6921C4",
    strokeWidth: 1.43749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59373 9.34375H2.15624C1.775 9.34375 1.40936 9.4952 1.13978 9.76478C0.8702 10.0344 0.71875 10.4 0.71875 10.7812V20.8437C0.71875 21.2249 0.8702 21.5906 1.13978 21.8601C1.40936 22.1297 1.775 22.2812 2.15624 22.2812H20.8436C21.2249 22.2812 21.5905 22.1297 21.8601 21.8601C22.1297 21.5906 22.2811 21.2249 22.2811 20.8437V10.7812C22.2811 10.4 22.1297 10.0344 21.8601 9.76478C21.5905 9.4952 21.2249 9.34375 20.8436 9.34375",
    stroke: "#6921C4",
    strokeWidth: 1.43749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4062 18.6874H10.0625",
    stroke: "#FF6019",
    strokeWidth: 1.43749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4062 15.0937H12.9375",
    stroke: "#FF6019",
    strokeWidth: 1.43749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7945_6867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheque);
export default __webpack_public_path__ + "static/media/Cheque.ea3a42a1.svg";
export { ForwardRef as ReactComponent };